import { render, staticRenderFns } from "./ModalInquiryAnswer.vue?vue&type=template&id=75067510&scoped=true"
import script from "./ModalInquiryAnswer.vue?vue&type=script&lang=js"
export * from "./ModalInquiryAnswer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75067510",
  null
  
)

export default component.exports